import { createTheme } from '@mui/material/styles';
/* Colors:
#443937 Earthy brown
#92321F Dark crimson
#F04A23 Fiery Orange
#D6A69A Skin Pink
#FFFFFF White
*/
export const brandColors = {
    light: '#D6A69A',
    main: '#92321F',
    borderGray: '#ECEEF2',
    tableBorder: 'rgba(224, 224, 224, 1)',
};
export const success = {
    light: '#EDFDF7',
    main: '#06A771',
    dark: '#047B53',
};
export const MakhazinTheme = createTheme({
    palette: {
        primary: {
            main: '#92321F',
            contrastText: '#FFFFFF',
            dark: '#443937' //Brown
        },
        secondary: {
            main: '#FFFFFF',
            contrastText: '#443937' //Brown
        },
        background: {
            default: '#D6A69A',
            paper: '#FFFFFF', //White
        },
        text: {
            primary: '#443937', //Brown
        }
    },
    typography: {
        fontFamily: ['Open Sans', 'Helvetica', 'Arial', 'sans-serif'].join(','),
        h1: {
            fontFamily: ['Be Vietnam', 'Helvetica', 'Arial', 'sans-serif'].join(','),
            marginTop: '1rem',
            fontSize: '2rem',
            fontWeight: 700,
            color: '#443937',
        },
        h2: {
            fontFamily: ['Be Vietnam', 'Helvetica', 'Arial', 'sans-serif'].join(','),
            fontSize: '1.6rem',
            color: '#443937',
        },
        h3: {
            fontFamily: ['Be Vietnam', 'Helvetica', 'Arial', 'sans-serif'].join(','),
            fontSize: '1.3rem',
            color: '#443937',
        },
        h4: {
            fontFamily: ['Be Vietnam', 'Helvetica', 'Arial', 'sans-serif'].join(','),
            fontSize: '1.1rem',
            color: '#443937',
        },
        h5: {
            fontFamily: ['Be Vietnam', 'Helvetica', 'Arial', 'sans-serif'].join(','),
            fontSize: '1rem',
            fontWeight: 'bold',
            color: '#443937',
        },
        h6: {
            fontFamily: ['Be Vietnam', 'Helvetica', 'Arial', 'sans-serif'].join(','),
            fontSize: '0.9rem',
            color: '#443937',
        },
        button: {
            fontFamily: ['Be Vietnam', 'Helvetica', 'Arial', 'sans-serif'].join(','),
            textTransform: 'capitalize',
            fontWeight: 300,
        },
        subtitle1: {
            fontWeight: 'bold',
        },
        overline: {
            fontSize: '0.9rem',
            fontWeight: 'bold',
            color: 'rgba(0, 0, 0, 0.6)',
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    fontWeight: 'bold',
                    padding: '8px 16px',
                },
                // To match size of contained
                outlinedSizeLarge: {
                    padding: '0.5rem 21px',
                },
                outlined: {
                    padding: '0.5rem 1rem',
                },
                contained: {
                    boxShadow: 'none',
                    '&:focus': {
                        boxShadow: 'none',
                    },
                    '&:hover': {
                        boxShadow: 'none !important',
                    },
                    '&:active': {
                        boxShadow: 'none',
                    },
                },
                endIcon: {
                    marginRight: 0,
                    marginLeft: '0.5rem',
                },
            },
        },
        MuiTable: {
            styleOverrides: {
                root: {
                    border: `1px solid ${brandColors.tableBorder}`,
                },
            },
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    width: '100%',
                },
                input: {
                    padding: '8px 0 6px',
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    fontWeight: 'bold',
                    fontSize: '0.9rem',
                    color: '#000',
                    lineHeight: 1.6,
                },
                formControl: {
                    position: 'static',
                    transform: 'none',
                },
                shrink: {
                    transform: 'inheirit',
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    boxShadow: 'none',
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    whiteSpace: 'nowrap',
                },
                head: {
                    fontWeight: 700,
                },
            },
        },
        MuiTablePagination: {
            styleOverrides: {
                input: {
                    flexShrink: 'inherit',
                    width: 'auto',
                },
            },
        },
        MuiSelect: {
            styleOverrides: {
                outlined: {
                    textAlign: 'left',
                },
                icon: {
                    right: '.5rem',
                },
            },
        },
        MuiTableFooter: {
            styleOverrides: {
                root: {
                    '& > td': {
                        fontSize: '1rem',
                        fontWeight: 'bold',
                        color: '#000',
                    },
                },
            },
        },
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    minWidth: 0,
                },
            },
        },
        MuiStepper: {
            styleOverrides: {
                horizontal: {
                    paddingLeft: 0,
                    paddingRight: 0,
                    marginBottom: '1rem',
                    alignItems: 'center',
                },
            },
        },
        MuiStepLabel: {
            styleOverrides: {
                label: {
                    whiteSpace: 'nowrap',
                    overflowX: 'hidden',
                    textOverflow: 'ellipsis',
                },
            },
        },
        MuiFormControlLabel: {
            styleOverrides: {
                root: {
                    marginBottom: '0.5rem',
                    marginLeft: 0,
                    marginRight: 0,
                    paddingTop: '0.5rem',
                    paddingBottom: '0.5rem',
                    borderRadius: 5,
                },
                label: {
                    width: '100%',
                },
            },
        },
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    '&.Mui-focused': {
                        color: 'black',
                    },
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    color: 'black',
                    '&:focus': {
                        color: 'black',
                        '& *': {
                            color: 'black !important',
                        },
                    },
                },
            },
        },
        MuiFab: {
            styleOverrides: {
                root: {
                    boxShadow: 'none',
                    backgroundColor: '',
                    color: '',
                },
            },
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    fontSize: '0.8rem',
                },
            },
        },
        MuiStepIcon: {
            styleOverrides: {
                root: {
                    MuiCompleted: {
                        color: `${success.main} !important`,
                    },
                },
            },
        },
        MuiAccordion: {
            styleOverrides: {
                root: {
                    boxShadow: 'none',
                    borderBottom: `1px solid #eee`,
                },
            },
        },
        MuiAccordionSummary: {
            styleOverrides: {
                root: {
                    padding: 0,
                    flexDirection: 'row-reverse',
                    minHeight: '64px',
                },
                content: {
                    margin: '1rem 0',
                },
                expandIconWrapper: {
                    marginRight: '1rem !important',
                    backgroundColor: brandColors.light,
                    '&:hover': {
                        backgroundColor: brandColors.main,
                    },
                },
            },
        },
        MuiAccordionDetails: {
            styleOverrides: {
                root: {
                    paddingLeft: 0,
                    paddingRight: 0,
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                label: {
                    fontWeight: 'bold',
                },
            },
        },
        MuiTypography: {
            styleOverrides: {
                h1: {
                    marginTop: '1rem',
                    fontSize: '2rem',
                    fontWeight: 700,
                },
                h2: {
                    fontSize: '1.6rem',
                },
                h3: {
                    fontSize: '1.3rem',
                },
                h4: {
                    fontSize: '1.1rem',
                },
                h5: {
                    color: '#616161',
                    fontSize: '1rem',
                    fontWeight: 'bold',
                },
                h6: {
                    fontSize: '0.9rem',
                },
                subtitle1: {
                    fontWeight: 'bold',
                },
                overline: {
                    fontSize: '0.9rem',
                    fontWeight: 'bold',
                    color: 'rgba(0, 0, 0, 0.6)',
                },
            },
        },
    },
    shape: {
        borderRadius: 0,
    },
    spacing: (factor) => `${0.5 * factor}rem`,
});
